<script lang="ts">
  import {
    Dropdown,
    FormGroup,
    FormLabel,
    RadioTile,
    TileGroup,
  } from "carbon-components-svelte";
  import { optionsData } from "../../ts/Stores";
  import { Helper } from "../../ts/Helper";
  import type { IBorder, IBorderOptions } from "../../ts/Interfaces";

  let options: IBorderOptions;
  export let border: IBorder;

  optionsData.subscribe((optionsData) => {
    options = optionsData.borderOptions;
  });

  let sizes = Helper.ToIdTextPair(
    Helper.getRange(
      options.minThickness,
      options.maxThickness,
      options.minThickness
    )
  );
</script>

<div class="stack">
  {#if !border.hideStyle}
    <TileGroup
      legend="Choose the border style"
      bind:selected={border.style}
      class="flex-wrap"
    >
      {#each options.styles as value}
        <RadioTile {value} class="border-{value}">{value}</RadioTile>
      {/each}
    </TileGroup>
  {/if}

  {#if !border.hideShape}
    <TileGroup
      legend="Choose the border shape"
      bind:selected={border.shape}
      class="flex-wrap"
    >
      {#each options.shapes as value}
        <RadioTile {value} class="shape-{value}">{value}</RadioTile>
      {/each}
    </TileGroup>
  {/if}

  {#if !border.hideThickness}
    <FormGroup noMargin>
      <Dropdown
        titleText="Choose the border thickness"
        items={sizes}
        bind:selectedId={border.thickness}
      />
    </FormGroup>
  {/if}
</div>
